"use client";
// import buildmapperagentIcon from "@/assets/sidenav/BuildMapperAgent.svg";
import buildmapperagentIcon from "@/assets/sidenav/buildmapper-ai-agent.svg";
// import logoutIcon from "@/assets/sidenav/logouts.svg"; 
import leadDataIcon from "@/assets/sidenav/lead-data.svg";
import crmIcon from "@/assets/sidenav/crm.svg";
import contactsIcon from "@/assets/sidenav/contacts.svg";
import quotesIcon from "@/assets/sidenav/quotes.svg";
// import marketingIcon from "@/assets/sidenav/marketing-auto.svg";
import signIcon from "@/assets/sidenav/sign.svg";
import invoicingIcon from "@/assets/sidenav/invoice.svg";
import calendarIcon from "@/assets/sidenav/calendar.svg";
import documentsIcon from "@/assets/sidenav/documents.svg"
import allAppsIcon from "@/assets/apps/allApps.svg";
import integrationIcon from "@/assets/integration/integration.svg";
// import discussIcon from "@/assets/sidenav/discuss.svg";
// import analyticsIcon from "@/assets/sidenav/analytics.svg"
// import profileSettingsIcon from "@/assets/sidenav/profile.svg";
import companyProfileIcon from "@/assets/myaccount/company-profile@2x.webp";
// import userProfileIcon from "@/assets/myaccount/userprofile.webp";
// import organizationUserIcon from "@/assets/myaccount/organisation-user.webp";
// import subscriptionIcon from "@/assets/myaccount/subscription.webp";
// import accountSettingIcon from "@/assets/myaccount/account-settings.svg";
// import builderWatchlistIcon from "@/assets/myaccount/watchlist@2x.webp"

import { IPrompts, SideNavMenu } from "@/components/side-nav-menu/side-nav";
import { useCallback, useEffect, useState } from "react";
import { getDashboardPrompts } from "./service";
import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
// import { logoutUser } from "../auth/UserSlice";
// import { useDispatch} from "react-redux";
// import { AppDispatch } from "@/store";
// import { useLoading } from "@/contexts/LoadingContext";



const LINK_ICON_STYLE = "size-[25px] flex-shrink-0 hover:scale-125";

export default function Layout() {
  // const navigate = useNavigate();
  // const {setLoading} = useLoading();

  // const logout = () => {
  //   try {
  //     setLoading(true);
  //     dispatch(logoutUser()).then(() => {
  //       // console.log("clicked");
  //       navigate(`/`);
  //       window.location.reload();
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const links1 = [
    {
      label: "BuildMapper Agent",
      href: "/dashboard/buildmapper_agent",
      icon: (
        <img
          src={buildmapperagentIcon}
          alt="lead data icon"
          className={LINK_ICON_STYLE}
          title="BuildMapper Agent"
        />
      ),
    },
    {
      label: "Lead Data",
      href: "explore_leads",
      icon: (
        <img
          src={leadDataIcon}
          alt="lead data icon"
          className={LINK_ICON_STYLE}
          title="Lead Data"
        />
      ),
    },
    {
      label: "CRM",
      href: "/dashboard/CRM",
      icon: (
        <img
          src={crmIcon}
          alt="crm icon"
          className={LINK_ICON_STYLE}
          title="CRM"
        />
      ),
    },
    {
      label: "Calendar",
      href: "calendar",
      icon: (
        <img
          src={calendarIcon}
          alt="calendar icon"
          className={LINK_ICON_STYLE}
          title="Calendar"
        />
      ),
    },
    { label: "Company Profile", href: "company-profile",icon: (
      <img
        src={companyProfileIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Company Profile"
      />
    ), },
    {
      label: "Contacts",
      href: "/dashboard/contacts",
      icon: (
        <img
          src={contactsIcon}
          alt="crm icon"
          className={LINK_ICON_STYLE}
          title="Contacts"
        />
      ),
    },
  
    {
      label: "Documents",
      icon: (
        <img
          src={documentsIcon}
          alt="documents icon"
          className={LINK_ICON_STYLE}
          title="Documents"
        />
      ),
      children: [
        {
          label: "Quotes",
          href: "/dashboard/quotes",
          icon: (
            <img
              src={quotesIcon}
              alt="quotes icon"
              className={LINK_ICON_STYLE}
              title="Quotes"
            />
          ),
        },
        {
          label: "Contracts",
          href: "/dashboard/contracts",
          icon: (
            <img
              src={signIcon}
              alt="contracts icon"
              className={LINK_ICON_STYLE}
              title="Contracts"
            />
          ),
        },
        {
          label: "Invoicing",
          href: "/dashboard/invoicing",
          icon: (
            <img
              src={invoicingIcon}
              alt="invoicing icon"
              className={LINK_ICON_STYLE}
              title="Invoicing"
            />
          ),
        },
      ],
    },
  
    // {
    //   label: "Quotes",
    //   href: "/dashboard/quotes",
    //   icon: (
    //     <img
    //       src={quotesIcon}
    //       alt="quotes icon"
    //       className={LINK_ICON_STYLE}
    //       title="Quotes"
    //     />
    //   ),
    // },
    // {
    //   label: "Contracts",
    //   href: "contracts",
    //   icon: (
    //     <img
    //       src={signIcon}
    //       alt="contracts icon"
    //       title="Contracts"
    //       className={LINK_ICON_STYLE}
    //     />
    //   ),
    // },
    // {
    //   label: "Invoicing",
    //   href: "invoicing",
    //   icon: (
    //     <img
    //       src={invoicingIcon}
    //       alt="invoicing icon"
    //       className={LINK_ICON_STYLE}
    //       title="Invoicing"
    //     />
    //   ),
    // },
    // {
    //   label: "Automation",
    //   href: "automation",
    //   icon: (
    //     <img
    //       src={marketingIcon}
    //       alt="marketing icon"
    //       className={LINK_ICON_STYLE}
    //       title="Marketing"
    //     />
    //   ),
    // },
    // {
    //   label: "Analytics",
    //   href: "#",
    //   icon: (
    //     <img
    //       src={analyticsIcon}
    //       alt="buildmapperagent icon"
    //       className={LINK_ICON_STYLE}
    //       title="BuildMapperagent"
    //     />
    //   ),
    // },
    // {
    //   label: "Discuss",
    //   href: "/dashboard/discuss/inbox",
    //   icon: (
    //     <img
    //       src={discussIcon}
    //       alt="discuss icon"
    //       className={LINK_ICON_STYLE}
    //       title="Discuss"
    //     />
    //   ),
    // },
    {
      label: "Integration",
      href: "/dashboard/integration",
      icon: (
        <img
          src={integrationIcon}
          alt="integration"
          className={LINK_ICON_STYLE}
          title="integration"
        />
      ),
    },
    {
      label: "All Apps",
      href: "/dashboard/all_apps",
      icon: (
        <img
          src={allAppsIcon}
          alt="all apps icon"
          className={LINK_ICON_STYLE}
          title="All Apps"
        />
      ),
    },
    
    // {
    //   label: "Profile Settings",
    //   icon: (
    //     <img
    //       src={profileSettingsIcon}
    //       alt="documents icon"
    //       className={LINK_ICON_STYLE}
    //       title="Profile Settings"
    //     />
    //   ),
    //   children: [
    //     { label: "Company Profile", href: "company-profile",icon: (
    //       <img
    //         src={companyProfileIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
    //     { label: "User Profile", href: "user-profile",icon: (
    //       <img
    //         src={userProfileIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
    //     { label: "Account Settings", href: "account-setting",icon: (
    //       <img
    //         src={accountSettingIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
    //     { label: "Subscriptions", href: "subscription",icon: (
    //       <img
    //         src={subscriptionIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
    //     { label: "Organizations Users", href: "organization-users",icon: (
    //       <img
    //         src={organizationUserIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
    //     { label: "Builder Watchlist", href: "builder-watchlist",icon: (
    //       <img
    //         src={builderWatchlistIcon}
    //         alt="all apps icon"
    //         className={LINK_ICON_STYLE}
    //         title="All Apps"
    //       />
    //     ), },
        
        
    //   ],
    // },
  
  //   { label: "Log Out", icon: (
  //     <img
  //       src={logoutIcon}
  //       alt="all apps icon"
  //       className={LINK_ICON_STYLE}
  //       title="Logout"
  //     />
  //   ), onClick:logout},
  ];

  const [allPrompts, setAllPrompts] = useState<Record<string, IPrompts>>({});
  const [prompts, setPrompts] = useState<IPrompts>([]);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const cookies = new Cookies();
  // const dispatch = useDispatch<AppDispatch>();
  
  useEffect(() => {
    const checkAuth = () => {
    const isAuth = cookies.get("isAuthenticated");

    console.log("isAuth", isAuth);
    setIsAuthenticated(isAuth);
    };
    checkAuth();
  }, []); 
 

  const location = useLocation();

  const getPrompts = useCallback(async () => {
    const response = await getDashboardPrompts();
    console.log("get prompts response", response);
    setAllPrompts(response.data.prompts);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
    getPrompts();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    console.log("prompts", allPrompts);
    console.log("location", location);
    let prom;
    const url = location.pathname;
    console.log("url", url);
    for (const k of Object.keys(allPrompts)) {
      if (url.toLowerCase().includes(k)) {
        prom = allPrompts[k];
      }
    }
    if (prom) {
      console.log("location prompts", prom);
      setPrompts(prom);
    }
  }, [allPrompts, location]);

  

  return <SideNavMenu navLinks={links1} prompts={prompts} />;
}
